import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginRequired = ({ currLang, currLocation }) => {
    const { loginWithRedirect } = useAuth0();
    return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
            <h2>{currLang === "IS" ? "Þú ert ekki skráð/ur inn?!" : "You are not logged in?!"}</h2>
            <p>{currLang === "IS" ? "Ansans skellur, það virðist sem þú ert ekki skráð/ur inn. Þú þarft að skrá þig inn ef þú vilt skoða þetta efni." : "Aww damn, it seems you are not logged in. You need to be logged in to view this page."}</p>
            <br />
            <button className="login-button" style={{ borderColor: "black", color: "black" }}
                onClick={() => loginWithRedirect({
                    appState: { returnTo: currLocation }
                })}>{currLang === "IS" ? "Skrá inn" : "Log in"}</button>
        </div>
    );
};

export default LoginRequired;